// extracted by mini-css-extract-plugin
module.exports = {"main":"main___I99IL","head":"head___3O4pW","list":"list___3iVWf","block":"block___1axy4"};